import { ApplicationEnum } from "~/@types/enums";
import buildMinimalRailShell from "~/components/dock/minimalRailShell";

const countRail = buildMinimalRailShell(
	ApplicationEnum.COUNT,
	[
		{ icon: "qr_code_scanner", id: "dashboard", path: "/count", title: "Dashboard" },
		{ icon: "view_list", id: "lines", path: "/count/lines", title: "Lines" },
		{ icon: "playlist_play", id: "sessions", path: "/count/sessions", title: "Sessions" },
		{ icon: "devices", id: "devices", path: "/count/devices", title: "Devices" },
		{ icon: "settings", id: "settings", path: "/count/admin/settings", title: "Settings" }
	],
	"qr_code_scanner"
);

export default countRail;
